<template>
  <div class="wrapper">
    <a name="pagetop" id="pagetop" class="sr">ページの先頭</a>
    <!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
        _/                                                                                                                    _/
        _/      会計事務所共通ヘッダ                                                                                          _/
        _/                                                                                                                    _/
    _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/-->
    <BusinessHeader v-if="this.isloginHendle"></BusinessHeader>
    <HeaderNav menuflg="2" v-else></HeaderNav>
    <!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
           _/                                                                                                                    _/
           _/      画面定義                                                                                                      _/
           _/                                                                                                                    _/
    _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/-->
    <div class="body">
      <div class="inner">
        <div class="pankuzu">
          <ul>
            <li>
              <router-link class="ico-home" :to="{ name: this.isloginHendle ? 'STFMFM02C29' : 'STFMFM01C01' }">
                {{ this.isloginHendle ? "ファイル一覧" : "メインページ" }}
              </router-link>
            </li>
            <li v-if="!this.isloginHendle">
              <router-link :to="{ name: 'STFMFM02C01' }">ファイル管理</router-link>
            </li>
            <li v-if="!this.isloginHendle">
              <router-link :to="{ name: 'STFMFM02C29' }">ファイル一覧</router-link>
            </li>
            <li>
              <span class="current">取引情報等の登録</span>
            </li>
          </ul>
        </div>
        <div class="content-header">
          <h1 class="h1">取引情報等の登録</h1>
          <p class="sub-title">{{ this.businessOperatorName }}</p>
        </div>
        <!-- ****  メッセージ表示領域 **** -->
        <p class="errMsg title-ico ico-warning" v-show="errors != ''">
          <ErrorMessage :errors="errors"></ErrorMessage>
        </p>
      </div>
      <div class="content-body2 content-body-border0">
        <div class="inner block" >
          <div class="register-status">
              <div class="progress">
                <div class="progress-bar" :style="('width: ' + this.percentage + '%')"></div>
              </div>
              <span class="register-size">{{ this.submittedCount }} ／ {{ this.fileCount }}ファイル</span>
            <button class="frm-btn text ml-0 check-btn" ref="checkFile" type="button"  @click="checkFile">
              スキャナ保存読取要件チェック
            </button>
          </div>

          <div class="property-wrap">
            <div class="property-left" style="background-color:#e9edf7">
              <div class="frm-row preview-control" v-if="pdfUrl != ''">
                <label>
                  <font>※PDFに変換して表示しているため実際のイメージと異なる場合がございます。</font>
                </label>
              </div>
              <div id="container" class="preview-area mt-8px height-1020px">
                <pdf-viewer  v-if="isMobile"  :url="pdfUrl"/>
                <iframe  v-if="!isMobile" id="iframeArea" width=100% height=100%; :src="pdfUrl" type="application/pdf" frameborder="0"
                  marginheight="0" marginwidth="0" border="0" scrolling="no" tabindex="-1">
                </iframe>

              </div>
            </div>
            <div class="property-right">
              <p><strong>取引情報</strong></p>
              <div class="para">
                <div class="frm-row">
                  <span class="frm-label w-100px">取引年月日</span>
                  <!-- No7日付のカレンダー入力対応 start-->
                  <DateCalandar ref="DateCalandar" :disabled="isErrorFlg" :wareki="{issueDateNengo,issueDateWarekiYear,issueDateWarekiMonth,issueDateWarekiDay}"
                    :errorInfo="{isIssueDateError,isNengoInputError,isYearInputError,isMonthInputError,isDayInputError}"
                  
                   @handleDateChange="handleDateChange"  ></DateCalandar>
                  <!-- <select class="frm-select frm-size-76px" :class="{ error: isIssueDateError | isNengoInputError }"
                    v-model="this.issueDateNengo" :disabled=isErrorFlg ref="refIssueDateNengo">
                    <option v-for="item in this.nengoList" :key="item" :value="item">
                      {{ item }}
                    </option>
                  </select>
                  <input title=" " type="url" maxlength="2" class="frm-text frm-size-xs number-input-right"
                    :class="{ error: isIssueDateError | isYearInputError }" v-model="this.issueDateWarekiYear"
                    :disabled=isErrorFlg />
                  <span class="frm-unit">年</span>
                  <input title=" " type="url" maxlength="2" class="frm-text frm-size-xs ml-5px number-input-right"
                    :class="{ error: isIssueDateError | isMonthInputError }" v-model="this.issueDateWarekiMonth"
                    :disabled=isErrorFlg>
                  <span class="frm-unit">月</span>
                  <input title=" " type="url" maxlength="2" class="frm-text frm-size-xs ml-5px number-input-right"
                    :class="{ error: isIssueDateError | isDayInputError }" v-model="this.issueDateWarekiDay"
                    :disabled=isErrorFlg>
                  <span class="frm-unit">日</span> -->
                  <!-- No7日付のカレンダー入力対応 end-->
                </div>
                <div class="detail-error" v-show="issueDateErrorMsg != ''">
                  {{ this.issueDateErrorMsg }}
                </div>
                <div class="frm-row">
                  <span class="frm-label w-100px">取引先</span>
                  <input type="text" maxlength="52" class="frm-text frm-size-full" :class="{ error: isCompanyErrorMsg }"
                    :disabled=isErrorFlg v-model="this.company" />
                </div>
                <div class="detail-error" v-show="companyErrorMsg != ''">
                  {{ this.companyErrorMsg }}
                </div>
                <div class="frm-row">
                  <span class="frm-label w-100px">取引金額</span>
                  <input title=" " type="url" maxlength="15" class="frm-text frm-size-160px number-input-right"
                    :class="{ error: isAmountError }" v-on:focusin="amountInputFocusin"
                    v-on:focusout="amountInputFocusOut" v-model="this.amount"
                    @input="amount = amount.replace(/[^\d]/g,'')"
                    :disabled=isErrorFlg ref="refAmout" />
                  <span class="frm-unit">円</span>
                </div>
                <div class="detail-error" v-show="amountErrorMsg != ''">
                  {{ this.amountErrorMsg }}
                </div>
              </div>
              <p><strong>プロパティ</strong></p>
              <div class="para">
                <div class="frm-row">
                  <span class="frm-label w-100px">名称</span>
                  <input type="text" maxlength="255" name="fileName" class="frm-text frm-size-full"
                    v-model.trim="fileName" v-bind:class="{ error: isErrorfileName }" :disabled=isErrorFlg />
                </div>
                <div class="detail-error" v-show="fileNameErrorMsg != ''">
                  {{ this.fileNameErrorMsg }}
                </div>
                <div v-show="fileNameErrorMsg != ''"><br></div>
                <!-- No4 書類ID start-->
                <div class="frm-row">
                    <span  class="frm-label w-100px">書類ID</span>
                    <span  class="ml-10px">
                      {{this.paperID}}
                    </span>           
                </div>
                <!-- No4 書類ID end-->
                <div class="frm-row">
                  <span class="frm-label w-100px">書類種別<span style="font-size:6px">(任意)</span></span>
                  <select class="frm-select frm-size-110px" v-model.trim="paperType" @change="handleChangePaperType"
                    :disabled=isErrorFlg>
                    <option v-for="item in this.paperTypeNameList" :key="item.code" :value="item.code">
                      {{ item.name }}
                    </option>
                  </select>
                  <span class="ml-10px">
                    <input type="text" maxlength="10" class="frm-text " style="width:205px"
                      v-model.trim="this.otherPaperTypeName" :disabled="isDisabled"
                      v-bind:class="{ error: isErrorOtherPaperTypeName }" />
                  </span>
                </div>
                <div class="detail-error" v-show="otherPaperTypeNameErrorMsg != ''">
                  {{ this.otherPaperTypeNameErrorMsg }}
                </div>
                <div v-show="otherPaperTypeNameErrorMsg != ''"><br></div>
                <div class="frm-row" style="display: flex;align-items:flex-start;">
                  <span class="frm-label w-100px">備考<span style="font-size:6px">(任意)</span>
                  </span>
                  <textarea type="text" maxlength="200" class="frm-text frm-size-full" name="remarks" rows="6"
                    v-model.trim="this.remarks" v-bind:class="{ error: isErrorRemarks }" :disabled=isErrorFlg>
                          </textarea>
                </div>
                <div class="detail-error" v-show="remarksErrorMsg != ''">
                  {{ this.remarksErrorMsg }}
                </div>
              </div>
              <div class="frm-btn-row footer-btn">
                <div class="frm-item grow between" v-if="!isErrorFlg">
                  <button class="frm-btn strong" @click="addFilePropertyInf">
                    登録
                  </button>
                  <button v-if="!this.isButtonHendle" class="frm-btn" ref="disagreeButton" @click="nextAdd">
                    後で登録
                  </button>
                  <button class="frm-btn" ref="disagreeButton" @click="$redirect({ name: 'STFMFM02C29' })" @blur="onblur">
                    後で登録<br>{{ !this.isButtonHendle ? "(以降すべて)" : "" }}
                  </button>
                </div>

                <div class="frm-item grow between" v-if="isErrorFlg">
                  <button v-if="!this.isButtonHendle" class="frm-btn strong" ref="nextButton" @click="nextPropertyInf">
                    次へ
                  </button>
                  <button v-if="this.isButtonHendle" class="frm-btn" :class="{ strong: this.isButtonHendle }" ref="endButton"
                    @click="$redirect({ name: 'STFMFM02C29' })" @blur="onblur">
                    終了
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- キャンセルボタン押下による確認画面 -->
    <ConfirmDialog :isShow="isShow" :message="content" @confirm="confirm" @cancel="cancel"></ConfirmDialog>
    <!-- No4スキャナ保存対応-スキャナ保存読取要件チェック-->
    <ConfirmDialog width="550" 
      :isShow="fileCheckSuccessedDialog.show" 
      :message="fileCheckSuccessedDialog.content" 
      @confirm="fileCheckConfirm" 
      :cancelText="fileCheckSuccessedDialog.cancelText"
      :confirmText="fileCheckSuccessedDialog.confirmText"
      >
    </ConfirmDialog>
  </div>
</template>
<script>
import _ from "lodash";
import { mapMutations } from "vuex";
import Common from "@/util/common.js";
import validation from "../../util/validation";
import HeaderNav from "@/components/AccountingHeader.vue";
import BusinessHeader from "@/components/BusinessHeader.vue";
import ErrorMessage from "@/components/ErrorMessage.vue";
import DateCalandar from "@/components/DateCalandar.vue";
import { getPDFApi } from "@/api/filemanage_download";
import { PAPERTYPE_LIST, } from "@/util/data.js";
import { API_STFMFM02C07_DisplayProperty, API_STFMFM02C07_AddProperty } from "@/api/Modules/FM02/STFMFM02C07.js";
import {
  API_STFMFM02C09_RequirementCheck,
} from "@/api/Modules/FM02/STFMFM02C09.js";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import PdfViewer from "@/components/PdfViewer.vue"
export default {
  name: "STFMFM02C07AddProperty",
  components: {
    HeaderNav,
    BusinessHeader,
    ErrorMessage,
    ConfirmDialog,
    DateCalandar,
    PdfViewer
  },
  data() {
    return {
      isMobile:Common.isMobile(),
      // 書類種類リスト
      //paperTypeNameList: new Array("","注文書","契約書","送り状","領収書","見積書","請求書","その他"),
      paperTypeNameList: PAPERTYPE_LIST, //書類種類リスト
      nengoList: new Array("", "令和", "平成"),
      // 遷移先ページ
      toPageId: "",
      // エラー情報格納用
      errors: [],
      errorName: [],
      //キャンセルボタン押下による確認画面
      cancelConfirmDialogSetting: {},
      fileName: "",
      fileDataName: "",
      fileKey:"",
      fileNameErrorMsg: "",
      //No4 書類ID
      paperID: "",
      paperType: "0",
      otherPaperTypeName: "",
      otherPaperTypeNameErrorMsg: "",
      issueDateNengo: "",
      issueDateWarekiYear: "",
      issueDateWarekiMonth: "",
      issueDateWarekiDay: "",
      issueDateErrorMsg: "",
      company: "",
      companyErrorMsg: "",
      amount: "",
      amountErrorMsg: "",
      remarks: "",
      remarksErrorMsg: "",
      pdfUrl: "",
      isloginHendle: this.$cookies.get("isloginHendle") == "true" ? true : false,
      // ファイル名必須入力
      isErrorFileName: false,
      isErrorOtherPaperTypeName: false,
      isIssueDateError: false,
      isNengoInputError: false,
      isYearInputError: false,
      isMonthInputError: false,
      isDayInputError: false,
      issueDateError: false,
      isCompanyErrorMsg: false,
      isAmountInputing: false,
      isAmountError: false,
      isErrorRemarks: false,
      errFlg: false,

      // 非表示項目
      isShowPop: false,
      isPageHendle: false,
      isButtonHendle: false,
      isErrorFlg: false,
      isCancelFlg: false,
      indexId: "",
      nextIndexId: "",
      businessOperatorName: "",
      percentage: 0,
      //処理件数
      submittedCount: 0,
      //処理全件数
      fileCount: 0,
      isShow: false, // 遷移提示表示
      content: "", // メッセージ
      isDisabled: true,
      isAiocr: true,
      //スキャナ保存対応-スキャナ保存読取要件チェック 
      fileCheckSuccessedDialog: {
        show: false,
        content: "",
        cancelText: "",
        confirmText: "OK",
      },
    };
  },
  beforeRouteLeave(to, from, next) {
    // 画面遷移チェック
    if (
      !this.$cookies.get("SessionID") ||
      to.name == "STDSCM04C06" ||
      this.toPageId ||
      this.isShowPop ||
      this.isErrorFlg
    ) {
      next();
    } else {
      this.toPageId = to;
      this.isShow = true;
    }
  },
  watch: {
    // **********************************************
    // * 取引年月日の年：数値のみで2桁まで入力
    // **********************************************
    issueDateWarekiYear: function (newVal, oldVal) {
      if (this.issueDateWarekiYear == "") {
      }
      if (this.issueDateWarekiYear != null && this.issueDateWarekiYear != "0") {
        this.issueDateWarekiYear = newVal.replace(/[^0-9]/g, '').replace(/^0+/, '');
      }
      if (this.issueDateWarekiYear != null && this.issueDateWarekiYear.length > 2) {
        this.issueDateWarekiYear = oldVal;
      }
    },
    // **********************************************
    // * 取引年月日の月：数値のみで2桁まで入力
    // **********************************************
    issueDateWarekiMonth: function (newVal, oldVal) {
      if (this.issueDateWarekiMonth == "") {
      }
      if (this.issueDateWarekiMonth != null && this.issueDateWarekiMonth != "0") {
        this.issueDateWarekiMonth = newVal.replace(/[^0-9]/g, '').replace(/^0+/, '');
      }
      if (this.issueDateWarekiMonth != null && this.issueDateWarekiMonth.length > 2) {
        this.issueDateWarekiMonth = oldVal;
      }
    },
    // **********************************************
    // * 取引年月日の日：数値のみで2桁まで入力
    // **********************************************
    issueDateWarekiDay: function (newVal, oldVal) {
      if (this.issueDateWarekiDay == "") {
      }
      if (this.issueDateWarekiDay != null && this.issueDateWarekiDay != "0") {
        this.issueDateWarekiDay = newVal.replace(/[^0-9]/g, '').replace(/^0+/, '');
      }
      if (this.issueDateWarekiDay != null && this.issueDateWarekiDay.length > 2) {
        this.issueDateWarekiDay = oldVal;
      }
    },

    // **********************************************
    // * 取引年月日の年号が空白の場合
    // * 年、月、日を空白に
    // **********************************************
    TradingDateWarekiNengoInputValue: function (newVal, oldVal) {
      if (this.TradingDateWarekiNengoInputValue == "") {
        this.TradingDateWarekiYearInputValue = "";
        this.TradingDateWarekiMonthInputValue = "";
        this.TradingDateWarekiDayInputValue = "";
      }
    },
    isErrorFlg: function (value) {
      this.$nextTick(() => {
        if (value && this.$refs.nextButton) {
          this.$refs.nextButton.focus()
        }
      })
    },
    isButtonHendle: function (value) {
      this.$nextTick(() => {
        if (value && this.$refs.endButton) {
          this.$refs.endButton.focus()
        }
      })
    },
  },

  computed: {
  },
  created() {
    // 画面遷移チェック用メッセージ初期化
    this.content = Common.getMessage("MTFM5180", [this.isAiocr ? "ファイル名より取得した取引情報またはAI-OCRで読み取りした取引情報" : "ファイル名より取得した取引情報"]);
  },
  mounted() {
    // this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    this.processDialogue(true);
    let config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
    API_STFMFM02C07_DisplayProperty(config).then(
      (response) => {
        //画面表示データ設定
        this.setDisplayProperty(response);
      }
    );
  },

  methods: {
    ...mapMutations("businessModule", [
      "processDialogue",
    ]),
    //画面表示データ設定
    async setDisplayProperty(response) {
      //正常の場合
      if (_.eq(response.result, "0000") || _.eq(response.result, "0001")) {
        // インデックス（画面表示用）
        this.indexId = response.indexId;
        // インデックス（次の画面表示用）
        this.nextIndexId = response.nextIndexId;
        // 事業所名
        this.businessOperatorName = response.businessOperatorName;
        // プロパティ登録件数
        this.submittedCount = response.propertyCount;
        // ファイル件数
        this.fileCount = response.fileCount;
        // 進捗パー
        this.percentage = _.divide(this.submittedCount, this.fileCount) * 100;
        // 画面ハンドル
        this.isPageHendle = response.isPageHendle;
        // ボタンハンドルフラグ
        this.isButtonHendle = response.isButtonHendle;
        // エラー有無フラグ
        this.isErrorFlg = response.isErrorFlg;
        // 取引先
        this.company = response.company;
        // 取引金額
        this.amount = response.amount;
        if (this.amount !== "" && this.amount != null) {
          this.amount = Number(this.amount).toLocaleString();
        }
        // 取引年月日（年号）
        this.issueDateNengo = response.issueDateNengo;
        // 取引年月日（年度）
        if (this.issueDateNengo == "") {
          this.issueDateWarekiYear = "";
        }
        else {
          this.issueDateWarekiYear = response.issueDateWarekiYear;
        }
        // 取引年月日（月）
        this.issueDateWarekiMonth = response.issueDateWarekiMonth;
        // 取引年月日（日）
        this.issueDateWarekiDay = response.issueDateWarekiDay;
        // ファイル名
        this.fileName = response.fileName;
        this.fileDataName = response.fileDataName;
        this.fileKey = response.fileKey;
        // 書類種類
        this.paperType = response.paperType;
        if (this.paperType == "7") {
          this.isDisabled = false;
        } else {
          this.isDisabled = true;
        }
        // その他の書類種別名
        this.otherPaperTypeName = response.otherPaperTypeName;
        // 備考
        this.remarks = response.remarks;
        this.errors = [];
        this.isAiocr = response.isAiocr;
        //書類ID
        this.paperID = response.paperID;
        // 画面遷移チェック用メッセージ初期化
        this.content = Common.getMessage("MTFM5180", [this.isAiocr ? "ファイル名より取得した取引情報またはAI-OCRで読み取りした取引情報" : "ファイル名より取得した取引情報"]);
        if (response.errorCD != null && response.errorCD != "") {
          // エラー表示
          if (response.errorName != null && response.errorName.length > 0) {
            this.errors.push(
              Common.createError(
                response.errorCD,
                Common.getMessage(response.errorCD, [response.errorName[0]])
              )
            );
          } else {
            var errPara = "";
            if (response.errorCD == "MTCL1105") {
              errPara = "表示";
            }
            this.errors.push(
              Common.createError(
                response.errorCD,
                Common.getMessage(response.errorCD, [errPara])
              )
            );
          }
          this.pdfUrl = "";
        }
        if (response.errorCD != "MTCL1105") {
          // 表示するPDFのファイルパス

          if(this.isMobile){
            this.pdfUrl = response.fileData
          } else {
            const res = await getPDFApi(response);
            this.pdfUrl = res.objURL + "#view=Fit";
          }
        }
      } else {
        // エラー表示
        if (response.errorName != null && response.errorName.length > 0) {
          this.errors.push(
            Common.createError(
              response.errorCD,
              Common.getMessage(response.errorCD, [response.errorName[0]])
            )
          );
        } else {
          this.errors.push(
            Common.createError(
              response.errorCD,
              Common.getMessage(response.errorCD, [])
            )
          );
        }
      }
      this.processDialogue(false);
      this.$nextTick(function () {
        this.formToTop();
        this.initFocus();
      });
    },
    /**
     * フラグの初期化
     */
    resetErrorFlg() {
      this.errors.splice(0);
      this.isDisabled = true;
      this.isErrorfileName = false;
      this.fileNameErrorMsg = "";
      this.isErrorOtherPaperTypeName = false;
      this.otherPaperTypeNameErrorMsg = "";
      this.isIssueDateError = false;
      this.isNengoInputError = false;
      this.isYearInputError = false;
      this.isMonthInputError = false;
      this.isDayInputError = false;
      this.issueDateErrorMsg = "";
      this.isCompanyErrorMsg = false;
      this.companyErrorMsg = "";
      this.isAmountError = false;
      this.amountErrorMsg = "";
      this.isErrorRemarks = false;
      this.remarksErrorMsg = "";
    },

    /**
     * 確定ボタン押下
    */
    addFilePropertyInf() {
      // エラー情報の初期化
      this.resetErrorFlg();
      this.isDisabled = false;
      this.checkInputData();
      if (this.errors.length > 0) {
        this.formToTop();
        return;
      }
      // パラメータ設定
      var wamount = "";
      if (this.amount == "" || this.amount == null) {
        wamount = "";
      }
      else {
        wamount = this.amount.replace(/,/g, "");
      }
      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      var wotherPaperTypeName = "";
      if (this.paperType != "7") {
        wotherPaperTypeName = "";
      }
      else {
        wotherPaperTypeName = this.otherPaperTypeName;
      }

      var nengo = this.issueDateNengo;
      if (nengo == "令和" && this.isNullOrEmpty(this.issueDateWarekiYear) && this.isNullOrEmpty(this.issueDateWarekiMonth) && this.isNullOrEmpty(this.issueDateWarekiDay)) {
        nengo = "";
      }
      this.processDialogue(true);
      // パラメータ設定
      let param = {
        // インデックス（画面表示用）
        indexId: this.indexId,
        // インデックス（次の画面表示用）
        nextIndexId: this.nextIndexId,
        // ファイル件数
        fileCount: this.fileCount,
        // 取引年月日（和暦）
        issueDateNengo: nengo,
        // 取引年月日（年度）
        issueDateWarekiYear: this.issueDateWarekiYear,
        // 取引年月日（月）
        issueDateWarekiMonth: this.issueDateWarekiMonth,
        // 取引年月日（日）
        issueDateWarekiDay: this.issueDateWarekiDay,
        // 取引先
        company: this.company,
        // 取引金額
        amount: wamount,
        // 備考
        remarks: this.remarks,
        // ファイル名
        fileName: this.fileName,
        //PDFファイル名
        fileDataName: this.fileDataName,
        // ファイル種類
        paperType: this.paperType,

        otherPaperTypeName: wotherPaperTypeName,
      };

      API_STFMFM02C07_AddProperty(param).then(
        (response) => {
          if (response.isPageHendle) {
            this.isShowPop = true;
            this.$router.push({
              name: "STFMFM02C29",
              params: {},
            });
          } else {
            this.isShowPop = false;
            //画面表示データ設定
            this.setDisplayProperty(response);
          }
        }
      );
    },

    // **********************************************
    // * 後で登録
    // **********************************************
    nextAdd() {
      this.toPageId = "STFMFM02C07";
      this.isShow = true;
    },
    // **********************************************
    // * 次へ
    // **********************************************
    nextPropertyInf() {
      // エラー情報の初期化
      this.resetErrorFlg();
      this.processDialogue(true);
      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      // パラメータ設定
      let param = {
        // インデックス（画面表示用）
        indexId: this.indexId,
        // インデックス（次の画面表示用）
        nextIndexId: this.nextIndexId,
        // ファイル件数
        fileCount: this.fileCount,
        //PDFファイル名
        fileDataName: this.fileDataName,

        //後で登録(以降すべて)ボタン処理フラグ
        isCancelFlg: false
      };

      API_STFMFM02C07_DisplayProperty(param).then(
        (response) => {
          this.isShowPop = false;
          //画面表示データ設定
          this.setDisplayProperty(response);
        }
      );
    },
    fileCheckConfirm() {
      this.fileCheckSuccessedDialog.show = false
    },
    // **********************************************
    // * キャンセル確認画面でOKボタン押下
    // **********************************************
    confirm() {
      // 遷移チェック：「OK」
      this.isShow = false;
      // エラー情報の初期化
      this.resetErrorFlg();
      //次への場合
      if (this.toPageId == "STFMFM02C07") {
        this.processDialogue(true);
        let config = {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        };
        // パラメータ設定
        let param = {
          // インデックス（画面表示用）
          indexId: this.indexId,
          // インデックス（次の画面表示用）
          nextIndexId: this.nextIndexId,
          // ファイル件数
          fileCount: this.fileCount,
          //PDFファイル名
          fileDataName: this.fileDataName,
          //後で登録(以降すべて)ボタン処理フラグ
          isCancelFlg: false
        };
        this.toPageId = "";
        API_STFMFM02C07_DisplayProperty(param).then(
          (response) => {
            this.isShowPop = false;
            //画面表示データ設定
            this.setDisplayProperty(response);
          }
        );
      } else {
        //キャンセルの場合
        // パラメータ設定
        let param = {
          // インデックス（画面表示用）
          indexId: this.indexId,
          // インデックス（次の画面表示用）
          nextIndexId: this.nextIndexId,
          // ファイル件数
          fileCount: this.fileCount,
          //PDFファイル名
          fileDataName: this.fileDataName,
          //後で登録(以降すべて)ボタン処理フラグ
          isCancelFlg: true
        };
        let config = {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        };
        // 遷移チェック：「OK」ボタン 非活性化
        this.isConfirmOKDisabled = true;
        API_STFMFM02C07_DisplayProperty(param).then(
          async (response) => {
            //正常の場合
            if (_.eq(response.result, "0000") || _.eq(response.result, "0001")) {

              this.closeForm();
            } else {
              // エラー表示
              this.errors.push(
                Common.createError(
                  response.errorCD,
                  Common.getMessage(response.errorCD, [])
                )
              );
            }
            // 遷移チェック：「OK」ボタン 活性化
            this.isConfirmOKDisabled = false;
          }
        );
      }
    },
    // **********************************************
    // * キャンセル確認画面でキャンセルボタン押下
    // **********************************************
    cancel() {
      // 遷移チェック：「キャンセル」
      this.isShow = false;
      this.toPageId = "";
    },

    /**
     * 呼び出し元画面へ遷移
    */
    closeForm() {
      this.$redirect(this.toPageId);
    },
    /**
     * 画面の最上位に移動
     */
    formToTop() {
      window.scroll({ top: 0, behavior: 'smooth' });
    },

    // **********************************************
    // * 書類種類設定
    // **********************************************
    handleChangePaperType(e) {
      this.paperType = e.target.value;

      if (this.paperType == "7") {
        this.isDisabled = false;
      } else {
        this.isDisabled = true;
      }
      this.otherPaperTypeName = "";
      this.isErrorOtherPaperTypeName = false;
    },
    // **********************************************
    // * 書類種類がその他かを判定
    // **********************************************
    // isOtherPaperTypeName() {
    //   this.otherPaperTypeName == "";
    //   return this.paperType == "7";
    // },
    /**
     * 金額入力項目のフォーカスイン
    */
    amountInputFocusin() {
      this.isAmountInputing = true;
      this.amount = this.amount.replace(/,/g, "");
    },
    /**
     * 金額入力項目のフォーカスアウト
    */
    amountInputFocusOut() {
      this.isAmountInputing = false;
      if (this.amount !== "") {
        if (validation.isInteger(this.amount)) {
          this.amount = Number(this.amount).toLocaleString();
        }
      }
    },
    /**
     * 入力値チェック
    */
    checkInputData() {
      if (!this.checkInputtedFileName()) {
        this.setErrMsg("MTCL1119", []);
      }

      if (!this.checkInputtedIssueDate()) {
        this.setErrMsg("MTCL1119", []);
      }

      if (!this.checkInputtedCompany()) {
        this.setErrMsg("MTCL1119", []);
      }

      if (!this.checkInputtedAmount()) {
        this.setErrMsg("MTCL1119", []);
      }

      if (!this.checkInputtedFileType()) {
        this.setErrMsg("MTCL1119", []);
      }

      if (!this.checkInputtedRemarks()) {
        this.setErrMsg("MTCL1119", []);
      }
      if (this.errors.length == 0) {
        this.checkDealingInfo();
      }
    },
    /**
     * ファイル名チェック
     */
    checkInputtedFileName() {
      // ファイル名チェック1-(6)     
      if (!this.isNullOrEmpty(this.fileName.trim())) {

        //拡張子が.html、.htmのファイルが含まれる　又はファイルの拡張子が存在しない。
        let file_type = this.fileName.split('.').pop();
        if (file_type == "html" || file_type == "htm" || file_type == "" || file_type == this.fileName) {
          this.isErrorfileName = true;
          // エラー表示
          this.fileNameErrorMsg = Common.getMessage("MTCL1107", []);
          return false;
        }

        // ファイル名に入力禁止文字が使用されている。
        // ※設計書『D - ED005_共通処理設計書.xlsx』参照。  
        if (
          !validation.checkNationalkinsokuchar(this.fileName) ||
          !validation.CheckFileNameInvalid(this.fileName)
        ) {
          this.isErrorfileName = true;
          // エラー表示
          this.fileNameErrorMsg = Common.getMessage("MTCL1098", ["名称"]);
          return false;
        }

        //.で始まる(1-7)
        //.拡張子を含めた文字列、又は拡張子を除いた文字列が以下のいずれかに該当する。
        //　COM0、COM、COM2、COM3、COM4、COM5、COM6、COM7
        //　COM8、COM9、LPT0、LPT1、LPT2、LPT3、LPT4、LPT5、
        //　LPT6、LPT7、LPT8、LPT9、CON、PRN、AUX、NUL、CLOCK$ 
        if (!validation.CheckFileName(this.fileName)) {
          this.isErrorfileName = true;
          // エラー表示
          this.fileNameErrorMsg = Common.getMessage("MTFM1190", ["名称"]);
          return false;
        }
      } else {
        //チェック1-(1)
        this.isErrorfileName = true;
        // エラー表示
        this.fileNameErrorMsg = Common.getMessage("MTCL1001", ["名称"]);
        return false;
      }
      return true;
    },
    /**
     * その他の書類種別チェック
     */
    checkInputtedFileType() {
      // その他の書類種別チェック1-(2)
      if (this.paperType == "7") {
        if (!this.otherPaperTypeName) {
          // エラー表示
          this.otherPaperTypeNameErrorMsg = Common.getMessage("MTFM1120", ["その他の書類種別"]);
          this.isErrorOtherPaperTypeName = true;
          return false;
        } else {
          // 入力禁止文字チェックその他の書類種別1-(6)
          if (!validation.checkNationalkinsokuchar(this.otherPaperTypeName) ||
            !validation.CheckFileNameInvalid(this.otherPaperTypeName)) {
            this.isErrorOtherPaperTypeName = true;
            // エラー表示
            this.otherPaperTypeNameErrorMsg = Common.getMessage("MTCL1098", ["その他の書類種別"]);
            return false;
          }
        }
      }
      return true;
    },
    /**
     * 取引年月日チェック
     */
    checkInputtedIssueDate() {
      var nengoVal = this.issueDateNengo.trim();
      var yearVal = this.issueDateWarekiYear.trim();
      var monthVal = this.issueDateWarekiMonth.trim();
      var dayVal = this.issueDateWarekiDay.trim();
      if (nengoVal == "令和" && this.isNullOrEmpty(yearVal) && this.isNullOrEmpty(monthVal) && this.isNullOrEmpty(dayVal)) {
        nengoVal = "";
      }

      // 取引年月日の半角数字チェック
      if (!this.isNullOrEmpty(yearVal) && !validation.isNumeric(yearVal)) {
        this.isYearInputError = true;
        // エラー表示
        this.issueDateErrorMsg = Common.getMessage("MTFM1110", []);
        return false;
      }
      if (!this.isNullOrEmpty(monthVal) && !validation.isNumeric(monthVal)) {
        this.isMonthInputError = true;
        // エラー表示
        this.issueDateErrorMsg = Common.getMessage("MTFM1110", []);
        return false;
      }
      if (!this.isNullOrEmpty(dayVal) && !validation.isNumeric(dayVal)) {
        this.isDayInputError = true;
        // エラー表示
        this.issueDateErrorMsg = Common.getMessage("MTFM1110", []);
        return false;
      }

      // [取引年月日]の日付妥当性チェック
      if (!this.isNullOrEmpty(nengoVal) || !this.isNullOrEmpty(yearVal) || !this.isNullOrEmpty(monthVal) || !this.isNullOrEmpty(dayVal)) {
        // 未入力と入力混在時エラー
        var cnt = 0;
        if (!this.isNullOrEmpty(nengoVal)) {
          cnt++;
        }
        if (!this.isNullOrEmpty(yearVal)) {
          cnt++;
        }
        if (!this.isNullOrEmpty(monthVal)) {
          cnt++;
        }
        if (!this.isNullOrEmpty(dayVal)) {
          cnt++;
        }
        if (cnt > 0 && cnt < 4) {
          // エラー表示
          this.isIssueDateError = true;
          this.issueDateErrorMsg = Common.getMessage("MTFM1100", [""]);
          return false;
        }

        // 年月日の整合性チェック
        var wreki = "0";
        if (nengoVal === "平成") {
          wreki = "1";
        }
        var msg = validation.checkFilterDate(
          "1",
          wreki,
          yearVal,
          monthVal,
          dayVal,
          "取引年月日"
        );
        if (msg !== "") {
          this.isIssueDateError = true;
          this.issueDateErrorMsg = Common.getMessage("MTFM1100", [""]);
          return false;
        }
        // 和暦有効判定
        var bRet = this.warekiCheck(Number(wreki), Number(yearVal), Number(monthVal), Number(dayVal));
        if (!bRet) {
          this.isIssueDateError = true;
          this.issueDateErrorMsg = Common.getMessage("MTCL1011", ["取引年月日"]);
          return false;
        }
      }
      return true;
    },
    /**
     * 金額チェック
    */
    checkInputtedAmount() {
      var inputtedAmount = this.amount.trim().replace(/,/g, "");

      // 整数チェック
      if (!this.isNullOrEmpty(inputtedAmount) && !this.isInteger(inputtedAmount)) {
        this.isAmountError = true;
        // エラー表示
        this.amountErrorMsg = Common.getMessage("MTCL1006", ["取引金額"]);
        return false;
      }
      return true;
    },
    /**
     * 取引先チェック
    */
    checkInputtedCompany() {
      var company = this.company.trim();
      if (!this.isNullOrEmpty(company)) {
        if (!validation.checkNationalkinsokuchar(this.company) ||
          !validation.CheckFileNameInvalid(this.company)) {
          this.isCompanyErrorMsg = true;
          // エラー表示
          this.companyErrorMsg = Common.getMessage("MTCL1098", ["取引先"]);
          return false;
        }
      }
      return true;
    },
    /**
     * 備考チェック
    */
    checkInputtedRemarks() {
      var remarks = this.remarks;
      if (!this.isNullOrEmpty(remarks)) {
        if (!validation.checkNationalkinsokuchar(this.remarks) ||
          !validation.CheckFileNameInvalid(this.remarks)) {
          this.isErrorRemarks = true;
          // エラー表示
          this.remarksErrorMsg = Common.getMessage("MTCL1098", ["備考"]);
          return false;
        }
      }
      return true;
    },
    /**
     * 取引情報セット入力チェック
    */
    checkDealingInfo() {
      var nengoVal = this.issueDateNengo.trim();
      var yearVal = this.issueDateWarekiYear.trim();
      var monthVal = this.issueDateWarekiMonth.trim();
      var dayVal = this.issueDateWarekiDay.trim();
      if (nengoVal == "令和" && this.isNullOrEmpty(yearVal) && this.isNullOrEmpty(monthVal) && this.isNullOrEmpty(dayVal)) {
        nengoVal = "";
      }

      var cnt = 0;
      if (this.isNullOrEmpty(nengoVal)) {
        cnt++;
      }
      if (this.isNullOrEmpty(this.company)) {
        cnt++;
      }
      if (this.isNullOrEmpty(this.amount)) {
        cnt++;
      }
      // すべて空白またはすべて入力の場合OK
      if (cnt == 0 || cnt == 3) {
        return true;
      }
      else {
        this.setErrMsg("MTFM1130", []);
        return false;
      }
      return true;
    },
    /**
     * エラー内容セット
     * @param {エラーコード} errCd 
     * @param {エラーコードの埋め込み文字} param 
     */
    setErrMsg(errCd, param) {
      if (this.errors.length == 0) {
        this.errors.push(
          Common.createError(
            errCd,
            Common.getMessage(errCd, param)
          )
        );
      }
    },
    /**
     * null,empty判定
     * @param {判定対象} val 
     */
    isNullOrEmpty(val) {
      if (val == null || val == "") {
        return true;
      }
      else {
        return false;
      }
    },
    // **********************************************
    // * 初期フォーカス設定
    // **********************************************
    initFocus() {
      this.$refs.checkFile.focus()

    },

    /**
       * 和暦有効判定
       * @param {*} reki 和暦
       * @param {*} year 年
       * @param {*} month 月
       * @param {*} day 日
       * @returns チェック結果 true  : チェックOK / false : チェックNG
       */
    warekiCheck(reki, year, month, day) {
      if (isNaN(reki) || isNaN(year) || isNaN(month) || isNaN(day)) return false

      if (reki == 1) { //1:平成　1年1月8日～31年４月30日まで
        //平成元年チェック
        if (year == 1) {
          if (month == 1) {
            if (day < 8) return false
          }
        }

        //令和元年以降チェック
        if (year == 31) {
          if (month >= 5) {
            if (day >= 1) return false
          }
        }

        if (year > 31 || year < 1) {
          return false
        }
      }
      if (reki == 0) { //0:令和　元年5月1日から
        //令和元年チェック
        if (year == 1 && month <= 4) {
          return false // 令和
        }

        if (year < 1) {
          return false
        }
      }
      return true
    },
    /**
     * 整数チェック
     * @param {string} input 
     */
    isInteger(input) {
      return (String(input).match(/^-?[0-9]+$/)) ? true : false;
    },

    /**
     * ```ts
     * 数値と"-"キーのみを受け付ける
     * "-"は以下の場合受け付けない
     *  1.入力後の文字列が整数ではない
     * ```
     * @param {キーイベント} e 
     */
    amountOnKeyPress(e) {
      var selectStart = this.$refs.refAmout.selectionStart;
      var selectEnd = this.$refs.refAmout.selectionEnd;
      // 0～9又は"-"の場合
      if ((e.charCode >= 48 && e.charCode <= 57) || e.charCode == 45) {
        var amount = this.amount;
        // カーソルのstart,end位置で文字列を分割
        var val1 = amount.substring(0, selectStart);
        var val2 = amount.substring(selectStart, selectEnd);
        var val3 = amount.substring(selectEnd, amount.length);

        // カーソルのstart前の文字列+入力キーコード対応の文字列+カーソルのend後の文字列が"-"又は整数かの判定
        amount = val1 + String.fromCharCode(e.charCode) + val3;
        if (amount == "-" || this.isInteger(amount)) {
          if (String(amount).replace("-", "").length > 15) {
            return false;
          }
          return true;
        }
        else {
          return false;
        }
      }
      else {
        return false;
      }
    },
    // No7日付のカレンダー入力対応 
    handleDateChange({issueDateNengo,issueDateWarekiYear,issueDateWarekiMonth,issueDateWarekiDay}){
      
      this.issueDateNengo = issueDateNengo ? issueDateNengo.toString():""
      this.issueDateWarekiYear = issueDateWarekiYear?issueDateWarekiYear.toString():""
      this.issueDateWarekiMonth = issueDateWarekiMonth?issueDateWarekiMonth.toString():""
      this.issueDateWarekiDay = issueDateWarekiDay?issueDateWarekiDay.toString():""
    },
    checkFile() {
      if(this.fileKey){
        this.resetErrorFlg();
        this.processDialogue(true);
        API_STFMFM02C09_RequirementCheck({ fileKey: this.fileKey}).then(
          (response) => {
            // 正常の場合
            if (_.eq(response.result, "0000")) {
              if (response.requirements) {
                this.fileCheckSuccessedDialog.content =
                Common.getMessage("MTFM8080",[response.resolution,response.gradation]);
              } else {
                this.fileCheckSuccessedDialog.content =
                Common.getMessage("MTFM8090",[response.resolution,response.gradation]);
              }
              this.fileCheckSuccessedDialog.show = true;
            } else {
              this.errors.push(
                Common.createError(
                  response.errorCD,
                  Common.getMessage(response.errorCD, [])
                )
              );
            }
          } 
        ).finally(()=>{
          this.processDialogue(false);
        })
      }
    },
  },

};
</script>
<style scoped>
.content-body2 .inner{
  padding-left: 40px;
}
.detail-error {
  margin-left: 110px;
  height: 20px;
  border: 0px solid #ACACAC;
  color: red;
}

.pdf-preview-area {
  display: block;
  background-color: #eef8fc;
  border: 1px solid #ACACAC;
  width: 965px;
  height: 995px;
}

.iframe-src {
  width: 100%;
  height: 990px
}

.content-body-border0 {
  border-top: 0px;
}
.frm-size-160px {
  width: 160px;
}
.register-size{
  display: inline-block;
  margin-right: 15px;
}
@media (max-width: 768px) {
  .content-body2 .inner{
    padding:0 15px;
  }
  .property-wrap .property-right{
    margin-left: 0;
  }
  .frm-row .date-picker-wrap{
    margin-left: 0;
  }
  .ml-10px{
    margin-left: 0 !important;
  }
  .detail-error{
    margin-left: 0;
  }
  .property-left>.preview-area{
    position: relative;
    width:calc(100vw - 50px);
    height: calc((100vw - 50px) * 1.48);
    
  }
  .register-status{
    flex-wrap: wrap;
  }
  .register-status .progress{
    flex:0 0 50vw;
    margin-left: 0;
  }
  .check-btn{
    margin-top: 15px;
  }
}
</style>